import React from 'react'
import Deals from '@components/deals'
import MainLayout from '@layouts/main-layout'

const DealsPage = () => {
  return (
    <>
      <Deals />
    </>
  )
}

DealsPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default DealsPage
